import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import InstagramFeed from './components/InstagramFeed';

export default function Portfolio() {
  const [isNavFixed, setIsNavFixed] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('전체');

  useEffect(() => {
    const handleScroll = () => {
      setIsNavFixed(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const categories = ['전체', '네일', '속눈썹', '헤어', '메이크업', '피부관리', '왁싱'];

  return (
    <div className="min-h-screen bg-white">
      <Navbar isFixed={isNavFixed} />

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6 bg-gradient-to-b from-pink-50/50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <h1 
            className="text-5xl md:text-6xl font-light text-gray-800 mb-6" 
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Portfolio
          </h1>
          <p className="text-base text-gray-600 mb-4">
            실제 고객 후기와 작업물을 인스타그램을 통해 확인하세요
          </p>
          <div className="flex items-center justify-center space-x-2 text-rose-400">
            <i className="ri-instagram-line text-xl"></i>
            <span className="text-sm font-medium">Instagram 실시간 연동</span>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="sticky top-16 z-40 bg-white/95 backdrop-blur-md border-b border-gray-100 px-6 py-4">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-center space-x-3 overflow-x-auto">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-5 py-2 text-sm font-medium rounded-full whitespace-nowrap transition-all cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-gradient-to-r from-rose-400 to-pink-400 text-white shadow-md'
                    : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Instagram Feeds */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <InstagramFeed selectedCategory={selectedCategory} />
        </div>
      </section>

      <Footer />
    </div>
  );
}
